
module.exports = {
  getParamId(props) {
    return props.match.params.id;
  },
  getParam(props, param) {
    return props.match.params[param];
  },
  loadGoogleMaps(callback) {
    // Google Maps must be loaded exactly ONCE per page. Loading a second copy
    // (e.g. this loader + react-google-maps' own `googleMapURL`, which use
    // different `libraries` params) corrupts the shared `window.google.maps`
    // namespace — Google shows "This page can't load Google Maps correctly" and
    // objects like LatLngBounds stop being recognised by map.fitBounds, which
    // throws "not a LatLngBounds... unknown property lat" and crashes the screen.
    // So defer to any already-loaded / in-flight Maps script instead of adding
    // another one (previously this only checked for its own #googleMaps script
    // and was blind to react-google-maps' script).

    // Already fully loaded (by any loader) — just run the callback.
    if (window.google && window.google.maps) {
      if (callback) callback();
      return;
    }

    // A Maps script is already on the page (ours or another loader's). Wait for
    // it rather than injecting a duplicate.
    const existingScript =
      document.getElementById('googleMaps') ||
      document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
    if (existingScript) {
      if (callback) existingScript.addEventListener('load', callback, { once: true });
      return;
    }

    // First loader on the page — inject our script.
    const script = document.createElement('script');
    const mapKey = process.env.UI_GOOGLE_API_KEY;
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${mapKey}&libraries=places&v=quarterly`;
    script.id = 'googleMaps';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };
  },
  sortItem(a, b, field) {
    const field1 = a[field].toUpperCase(); // ignore upper and lowercase
    const field2 = b[field].toUpperCase(); // ignore upper and lowercase
    if (field1 < field2) {
      return -1;
    }
    if (field1 > field2) {
      return 1;
    }
    return 0;
  },
};
